














































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ImgUpload from "@components/ImgUpload.vue";
import { Form as ElForm } from "element-ui";
import { IMediaModel } from "@/data/commonModel";
import { addPackage, updatePackage } from "@/remote/package";
import { IPackageReqModel, IPackageModel } from "../data/packageModel";

interface IPackageFormModel {
  // type: string;
  title: string;
  // appId: string;
  subTitle: string;
  // redirectLink: string;
  // coverImages: IMediaModel[];
  // packageImages: IMediaModel[];
  // videoBgImages: IMediaModel[];
  // videos: IMediaModel[];
  image: IMediaModel[]
}

// 装饰器模式
@Component({
  components: {
    ImgUpload,
    ElForm,
  },
})
export default class extends Vue {
  // 显示或隐藏
  @Prop({
    default: false,
  })
  dialogFormVisible!: boolean;
  // 编辑类型
  @Prop({
    default: "add",
  })
  editType!: string;
  // editType = 'edit'时所需要的数据
  @Prop() packageModel!: IPackageModel;

  // Data
  formLabelWidth: string = "140px";
  formValueWidth: number = 450;
  formParams: IPackageFormModel = {
    // type: "image",
    title: "",
    // appId: "",
    subTitle: "",
    // redirectLink: "",
    // coverImages: [],
    // packageImages: [],
    // videoBgImages: [],
    // videos: [],
    image: [],
  };

  packageId: string = "";
  saveBtnLoading: boolean = false;
  titleLength: number = 0;
  subTitleLength: number = 0;
  videoMaxSize: number = 1024 * 49;

  // Rules
  rules = {
    image: {
      type: "array",
      required: true,
      trigger: "focus",
      message: "请选择套餐图片",
    },
    // coverImages: {
    //   type: "array",
    //   required: true,
    //   trigger: "focus",
    //   message: "请选择视频封面图片",
    // },
    // videoBgImages: {
    //   type: "array",
    //   required: true,
    //   trigger: "focus",
    //   message: "请选择视频背景图片",
    // },
    // videos: {
    //   type: "array",
    //   required: true,
    //   trigger: "focus",
    //   message: "请选择视频",
    // },
    // appId: {
    //   type: "string",
    //   required: true,
    //   trigger: "blur",
    //   message: "请输入要跳转的小程序appId",
    // },
  };

  // Computed
  get uploadImageItemWidth() {
    return `${(this.formValueWidth - 20) / 5}px`;
  }

  // Watch
  @Watch("packageModel", {
    immediate: true,
    deep: true,
  })
  onPackageModelChange(value: IPackageModel) {
    if (!value) return;
    // console.log("onPackageModelChange");
    // console.log(value);
    const model = JSON.parse(JSON.stringify(value));
    this.packageId = model.id;

    this.formParams = {
      // type: model.type === 0 ? "image" : model.type === 1 ? "video" : "appId",
      title: model.title,
      subTitle: model.subtitle,
      // appId: model.appId,
      // redirectLink: model.redirectLink,
      // coverImages: model.type === 1 ? [model.videoCoverImage] : [],
      // packageImages:
      //   model.type === 0 || model.type === 2 ? [model.imageCoverImage] : [],
      // videoBgImages: model.type === 1 ? [model.videoBackgroundImage] : [],
      // videos: model.type === 1 ? [model.video] : [],
      image: [model.image]
    };
    this.subTitleLength = this._calcTextLength(this.formParams.subTitle);
    this.titleLength = this._calcTextLength(this.formParams.title);
  }

  @Watch("formParams", {
    immediate: true,
    deep: true,
  })
  onFormParamsChange(value: IPackageFormModel) {
    // const { coverImages, packageImages, videoBgImages, videos } = value;
    // const form = this.$refs["packageForm"] as ElForm;
    // if (form && coverImages.length > 0) {
    //   // form.validateField('coverImages')
    // }
    // if (form && packageImages.length > 0) {
    //   form.validateField("packageImages");
    // }
    // if (form && videoBgImages.length > 0) {
    //   form.validateField("videoBgImages");
    // }
    // if (form && videos.length > 0) {
    //   form.validateField("videos");
    // }
  }

  // Methods
  _beforeModalClose() {
    this.$emit("update:dialogFormVisible", false); // 直接修改父组件的属性
  }

  _hide() {
    this.$emit("update:dialogFormVisible", false);
  }

  _onInput(event: any, type: string) {
    var value = event.target.value.trimStart();
    var temp = 0;
    var maxLen = type === "subTitle" ? 172 : 62;

    if (value.length === 0 && type === "title") {
      this.titleLength = 0;
    } else if (value.length === 0 && type === "subTitle") {
      this.subTitleLength = 0;
    }

    for (var i = 0; i < value.length; i++) {
      if (/[\u4e00-\u9fa5]/.test(value[i])) {
        temp += 2;
      } else {
        temp++;
      }
      if (temp > maxLen) {
        // @ts-ignore
        value = value.substr(0, i).trimStart();
      }
    }
    if (type === "title") {
      this.formParams.title = value;
      this.titleLength = temp > maxLen ? maxLen : temp;
    } else {
      this.formParams.subTitle = value;
      this.subTitleLength = temp > maxLen ? maxLen : temp;
    }
  }

  _calcTextLength(value: string): number {
    let temp = 0;
    for (var i = 0; i < value.length; i++) {
      if (/[\u4e00-\u9fa5]/.test(value[i])) {
        temp += 2;
      } else {
        temp++;
      }
    }
    return temp;
  }

  _onClickConfirm() {
    const form = this.$refs["packageForm"] as ElForm;
    form.validate((valid: Boolean) => {
      if (valid) {
        this._showConfirmToast();
      } else {
        return false;
      }
    });
  }

  _showConfirmToast() {
    this.$confirm(
      this.editType === "edit"
        ? "确认更新该套餐吗？"
        : "确认保存为新的套餐吗？",
      "提示",
      {
        confirmButtonText: this.editType === "edit" ? "更新" : "保存",
        cancelButtonText: "取消",
        center: true,
      }
    )
      .then(() => {
        this._handleFormData();
      })
      .catch(() => {});
  }

  _onClickCancel() {
    this.$confirm("", "确认放弃编辑吗？", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      center: true,
    })
      .then(() => {
        this._hide();
      })
      .catch(() => {});
  }

  // 处理表单数据
  _handleFormData() {
    const params = JSON.parse(JSON.stringify(this.formParams));
    const formParams = this.formParams;
    const reqModel: IPackageReqModel = {
      // type:
      //   formParams.type === "image" ? 0 : formParams.type === "appId" ? 2 : 1,
      title: formParams.title,
      subtitle: formParams.subTitle,
      image: formParams.image
      // introductionMediaId: formParams.introductionMediaId,
      // appId: formParams.appId,
      // redirectLink: formParams.redirectLink,
      // imageCoverImageId:
      //   formParams.type === "image" || formParams.type === "appId"
      //     ? formParams.packageImages && formParams.packageImages[0].id
      //     : undefined,
      // videoCoverImageId:
      //   formParams.type === "video"
      //     ? formParams.coverImages && formParams.coverImages[0].id
      //     : undefined,
      // videoBackgroundImageId:
      //   formParams.type === "video"
      //     ? formParams.videoBgImages && formParams.videoBgImages[0].id
      //     : undefined,
      // videoId:
      //   formParams.type === "video"
      //     ? formParams.videos && formParams.videos[0].id
      //     : undefined,
    };

    this.saveBtnLoading = true;
    if (this.editType === "edit") {
      this._updatePackage(reqModel);
    } else {
      this._createPackage(reqModel);
    }
  }

  // 新增
  async _createPackage(reqModel: IPackageReqModel) {
    try {
      const res = await addPackage(reqModel);
      if (res.status === 200) {
        this.$message.success("保存成功");
        this.$emit("onEditPackageSuccess", this.editType);
        this._hide();
      }
      this.saveBtnLoading = false;
    } catch {
      this.saveBtnLoading = false;
      // console.log("_createPackage出错了");
    }
  }

  // 编辑
  async _updatePackage(reqModel: IPackageReqModel) {
    try {
      const res = await updatePackage(this.packageId, reqModel);
      if (res.status === 200) {
        this.$message.success("保存成功");
        this.$emit("onEditPackageSuccess", this.editType);
        this._hide();
      }
      this.saveBtnLoading = false;
    } catch {
      this.saveBtnLoading = false;
      // console.log("_updatePackage 出错了");
    }
  }
}
